import { useMemo } from "react";
import { useProfile } from "./auth";
import { AccountInfo } from "./types";
import { useProducts } from "./useProducts";

export function useAccountInfo(account): AccountInfo | null {
  const { profile } = useProfile();
  const productsInfo = useProducts();
  const product =
    productsInfo.data?.find((p) => p.id === account?.product_id) ?? null;

  const accountInfo = useMemo(
    () =>
      product === null || !profile
        ? null
        : {
            accountId: account.account_id,
            accountNumber: account.account_number,
            cardName: product.name,
            canHaveRewardPoints: [
              "GO Mastercard",
              "GO Platinum Mastercard",
              "Latitude Infinity Rewards Visa",
              "Latitude Infinity Rewards Platinum Visa",
            ].includes(product.name),
            cardEndsWith: account.credit_card.linked_card_last4,
            cardImageFilename: product.card_image,
            cardMinCreditLimit: product.min_credit_limit ?? 0,
            cardMaxCreditLimit: product.max_credit_limit ?? Infinity,
            cardMmpPercentage: account.mmp_percentage,
            cardMmpThreshold: account.mmp_threshold,
            cardToken: account.credit_card.token,
            currentBalance: account.credit_card.current_balance,
            availableBalance: account.credit_card.available_balance,
            creditLimit: account.credit_card.credit_limit,
            userEmail: profile.email,
            userName: profile.name,
            isNZ: product.region === "NZ",
            isClosed: account.status === "CLOSED",
            contact: product.contact,
            productCode: product.code,
          },
    [account, product, profile],
  );

  return accountInfo;
}
